import PropTypes from 'prop-types';
export const I18nProviderShape = PropTypes.shape({
  langRegistry: PropTypes.object.isRequired,
  // Hard to define
  localePromise: PropTypes.instanceOf(Promise).isRequired,
  register: PropTypes.func.isRequired,
  setLocale: PropTypes.func.isRequired
});